// extracted by mini-css-extract-plugin
export default {"container":"menu_container__HufbY","menu":"menu_menu__L48Nr","cards":"menu_cards__0bNU5"};